import(/* webpackMode: "eager" */ "/data1/service/node_modules/.pnpm/next@13.4.19_react-dom@18.2.0_react@18.2.0_sass@1.66.1/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/data1/service/src/components/Report.jsx");
import(/* webpackMode: "eager" */ "/data1/service/src/components/Header.jsx");
import(/* webpackMode: "eager" */ "/data1/service/src/app/normalize.css");
import(/* webpackMode: "eager" */ "/data1/service/src/app/global.scss")